// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"d5106bd7","510":"98eda53b","564":"e9a54a06"}[chunkId] + ".chunk.css";
};